export const permissionsKeyMap = {
  dashboard: {
    parent: 'dashboardParent',
    children: {
      dashboard: 'dashboard'
    }
  },
  donor: {
    parent: 'donorsParent',
    children: {
      donors: 'donors'
    }
  },
  pledge: {
    parent: 'pledgesParent',
    children: {
      pledges: 'pledges'
    }
  },
  project: {
    parent: 'projectsParent',
    children: {
      projects: 'projects'
    }
  },
  sponsorship: {
    parent: 'sponsorshipParent',
    children: {
      sponsorships: 'sponsorships',
      beneficiaries: 'beneficiaries',
      sponsoredList: 'sponsoredList',
      unsponsoredList: 'unsponsoredList',
      sponsorshipManagement: 'sponsorshipManagement',
      sponsorshipDonation: 'sponsorshipDonation',
      sponsorshipReports: 'sponsorshipReports',
      sponsorshipValues: 'sponsorshipValues'
    }
  },
  facilities: {
    parent: 'facilitiesParent',
    children: {
      school: 'school',
      mosque: 'mosque',
      hospital: 'hospital',
      orphanage: 'orphanage'
    }
  },
  donation: {
    parent: 'donationParent',
    children: {
      donations: 'donations',
      allDonations: 'allDonations',
      addDonation: 'addDonation',
      donationSettings: 'donationSettings',
      donationPackages: 'donationPackages',
      urgentAppeals: 'urgentAppeals'
    }
  },
  giftAid: {
    parent: 'giftAidParent',
    children: {
      giftAid: 'giftAid'
    }
  },
  eventScheduler: {
    parent: 'eventSchedulerParent',
    children: {
      eventScheduler: 'eventScheduler'
    }
  },
  settings: {
    parent: 'settingsParent',
    children: {
      organizationDetails: 'organizationDetails',
      users: 'users',
      personal: 'personal',
      branches: 'branches',
      payment: 'payment',
      smtp: 'smtp'
    }
  }
};

export const userActions = {
  read: 'read',
  create: 'create',
  update: 'update',
  delete: 'delete',
  manage: 'manage'
};
